module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    class: [{
      'weui-cells__tips': _vm.tips,
      'weui-cells__title': !_vm.tips
    }]
  }, [_vm._t("default")], true)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-59698ee7!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/cells/cells-tips.vue
// module id = 247
// module chunks = 0